/**
 * Tidio Chat: client-side script loader.
 * Docs: https://www.tidio.com/panel/integration/
 */

const LOCALE_PREF_KEY = 'i18n-locale'

const TIDIO_LANG: Record<string, string> = { uk: 'uk', ru: 'ru' }

/**
 * Визначає мову для Tidio:
 * - якщо користувач явно вибрав uk/ru — використовуємо відповідну
 * - якщо вибрав іншу мову (en, de, тощо) — English
 * - якщо нічого не вибирав (немає збереженого префа) — Ukrainian за замовчуванням
 */
function resolveTidioLang(currentLocale: string): string {
  const stored = localStorage.getItem(LOCALE_PREF_KEY)
  if (!stored) return 'uk'
  return TIDIO_LANG[stored] ?? 'en'
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const { $i18n } = useNuxtApp()

  const key = String(config.public.tidioKey || '').trim()
  const enabledRaw = config.public.tidioEnabled
  const enabled = String(enabledRaw ?? 'true').toLowerCase() === 'true'

  if (!enabled || !key) return

  const src = `https://code.tidio.co/${key}.js`

  const applyLanguage = () => {
    const api = window.tidioChatApi
    if (!api) return
    api.setLanguage(resolveTidioLang(String($i18n.locale.value)))
  }

  const loadTidio = () => {
    if (document.querySelector(`script[src="${src}"]`)) return
    document.addEventListener('tidioChat-ready', applyLanguage, { once: true })
    const script = document.createElement('script')
    script.async = true
    script.src = src
    document.head.appendChild(script)
  }

  /** Defer Tidio so first paint / critical JS are not blocked (~5s after client boot). */
  window.setTimeout(loadTidio, 5000)

  watch($i18n.locale, applyLanguage)
})

declare global {
  interface Window {
    tidioChatApi?: {
      setLanguage: (lang: string) => void
    }
  }
}
